import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ToastComponent } from '../../shared/toast/toast.component';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { User } from '../../shared/models/user.model';
import { ee, profilePics } from '../../shared/constants';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  standalone: false
})
export class UserComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);
  private userService = inject(UserService);
  toast = inject(ToastComponent);


  @Input() user: User;

  isDetailsPage = false;
  isEditUserModalVisible = false;
  canDisableUser = false;
  canLastLogin = false;
  canEditJob = false;
  field = '';
  profilePics = profilePics;

  ngOnInit(): void {
    if (!this.user) {
      this.toast.setMessage('This user does not exists!', 'danger');
      this.router.navigate(['/team']);
      return;
    }
    this.canDisableUser = this.auth.currentUser.permissions.includes('disableUser');
    this.canLastLogin = this.auth.currentUser.permissions.includes('lastLogin');
    this.canEditJob = this.auth.currentUser.permissions.includes('editJob');
    if (this.router.url.includes('user/')) {
      this.isDetailsPage = true;
    }
  }

  toggleEditUserModal(field: string): void {
    this.isEditUserModalVisible = true;
    this.field = field;
    ee.emit('showEditUserModal', field);
  }

  goToAccount(): void {
    this.router.navigate(['/account']);
  }

  disableUser(user: User): void {
    if (window.confirm(`Are you sure you want to disable ${user.username}? They won't be able to login again.`)) {
      this.userService.disable(user)
        .pipe(finalize(() => this.router.navigate(['/team'])))
        .subscribe({
          next: res => this.toast.setMessage('User disabled successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }

  deleteUser(user: User): void {
    if (window.confirm(`Are you sure you want to delete ${user.username}?`)) {
      this.userService.delete(user)
        .pipe(finalize(() => this.router.navigate(['/team'])))
        .subscribe({
          next: res => this.toast.setMessage('User deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }

}
